document.addEventListener('DOMContentLoaded', () => {
  /**
   * Number regex input
   * @param str
   * @returns {boolean}
   */
  function numberRegexInput(str) {
    const regex = /^[0-9]+$/;
    return regex.test(str);
  }

  /**
   * formInputNumber
   * @return boolean
   */
  function formInputNumber() {
    const availableKeyCodes = [8, 9, 37, 38, 39, 40, 46];

    document.querySelectorAll('.wpcf7-validates-as-number').forEach((input) => {
      input.addEventListener('keydown', (event) => {
        if (numberRegexInput(event.key) === false
          && availableKeyCodes.indexOf(event.keyCode) === -1) {
          event.preventDefault();

          return false;
        }

        return true;
      });
    });
  }

  formInputNumber();
});
